import React from 'react';
import {useStyleContext} from "../../customHooks/useStyleContext";
import cx from "classnames";

function normalizeMoneyInput(value) {
    if (value == null) return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string') return null;

    const s = value
        .trim()
        .replace(/[\s\u00A0\u202F]/g, '')
        .replace(',', '.');

    if (s === '') return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}

function formatMoneyInline(value, { decimals = 2, locale } = {}) {
    const n = normalizeMoneyInput(value);
    const safe = n == null ? 0 : n;
    const resolvedLocale = locale || (typeof navigator !== 'undefined' ? navigator.language : 'fr-FR');
    try {
        return new Intl.NumberFormat(resolvedLocale, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(safe);
    } catch (e) {
        return safe.toFixed(decimals);
    }
}

const PriceDisplay = ({
    amount,
    decimals = 2,
    className,
    disableFormat = false,
    currencySymbol,
}) => {

    const styleContext = useStyleContext();

    const formattedAmount = disableFormat ? amount : formatMoneyInline(amount, { decimals });
    const symbol = currencySymbol ?? styleContext?.currency?.symbol ?? '';

    return (
        <span className={cx('no-tr', className)}>
            {formattedAmount}
            {symbol ? `\u00A0${symbol}` : ''}
        </span>
    );
};

export default PriceDisplay;
